import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import "@wbc/ui/tokens.css";
import "@wbc/ui/wbc-button.css";
import "./styles/global.css";

import SplashPage from "./pages/SplashPage.jsx";

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Missing #root element in index.html");

createRoot(rootElement).render(
  <StrictMode>
    <BrowserRouter>
      <Routes>
        {/* /MID is the real entry point; / is the no-MID fallback. */}
        <Route path="/" element={<SplashPage />} />
        <Route path="/:mid" element={<SplashPage />} />
        <Route path="*" element={<SplashPage />} />
      </Routes>
    </BrowserRouter>
  </StrictMode>,
);
